/**
 * Pre-launch market slug derivation utility (SCRUM-1463)
 *
 * Derives a market slug from a URL pathname.
 * Used by withPreLaunchProtection() in routes.jsx to call the per-market
 * config endpoint: GET /api/v1/pre-launch/config/:marketSlug
 */

// Known market slugs — must match landing_page_market_config.market_slug values
const KNOWN_MARKET_SLUGS = ['colorado', 'jackson-hole'];

/**
 * Derive market slug from a URL pathname (AC-01, SCRUM-1463).
 * Checks each known slug as a path segment: /colorado/... → 'colorado'.
 * Returns null if no known slug found (caller falls back to global config).
 *
 * @param {string} pathname - URL pathname (e.g., '/colorado/guides')
 * @returns {string|null}
 */
export function deriveMarketSlugFromPath(pathname) {
  if (!pathname) { return null; }
  const segments = pathname.split('/').filter(Boolean);
  for (const slug of KNOWN_MARKET_SLUGS) {
    if (segments.includes(slug)) {
      return slug;
    }
  }
  return null;
}
